import type {ExtendedPromise, OttoNexus} from "@otto-ec/global-resources/nexus";
import {apps} from "../index";

export type HapticFeedbackRaw = {
    /**
 *
 */
    triggerHapticFeedback(): ExtendedPromise;
}

export type HapticFeedback = OttoNexus["apps"]["hapticFeedback"]

/**
 *
 */
export const hapticFeedback: HapticFeedback = apps.hapticFeedback;

/**
 *
 */
export const triggerHapticFeedback: HapticFeedback["triggerHapticFeedback"] = hapticFeedback.triggerHapticFeedback;